// removed by extract-text-webpack-plugin
module.exports = {"TrdResult":"TrdResult__-loca-__1y--2","Highlight":"TrdResult__-loca-__2AZm0","Index":"TrdResult__-loca-__1f3V7","RegName":"TrdResult__-loca-__17GM8","Paypal":"TrdResult__-loca-__39sqw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/TrdAdminFocus/TrdResult/TrdResult.css
// module id = 199
// module chunks = 0